import getUrl from '@utils/url-utils'

import {baseApi} from './base.slice'

const GAME_TYPES_ENDPOINT = 'game-types'
const BASE_GAME_TYPE_URL = new URL(
	`${process.env.GATSBY_BACKOFFICE_BASE_URL}/${GAME_TYPES_ENDPOINT}`
).toString()

export const gameTypeApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getGameTypes: builder.query<
			GameType[],
			{
				filter?: {property: string; value: string}
				sort?: {direction: 'asc' | 'desc'; property: string}
			}
		>({
			query: ({sort, filter}) => {
				const url = getUrl(BASE_GAME_TYPE_URL, {
					queryParams: new Map([
						['orderBy', sort ? `${sort.property}.${sort.direction}` : ''],
					]),
				})

				if (filter?.property && filter?.value) {
					url.searchParams.set(`gameType.${filter?.property}`, filter?.value)
				}

				return {
					input: url.toString(),
					init: {method: 'GET'},
				}
			},
			providesTags: ['GameTypes'],
		}),
		getGameType: builder.query<GameTypeDetail, string>({
			query: (gameTypeId) => {
				const url = getUrl(BASE_GAME_TYPE_URL, {
					appendPath: `${GAME_TYPES_ENDPOINT}/${gameTypeId}`,
				})

				return {
					input: url.toString(),
					init: {method: 'GET'},
				}
			},
			providesTags: ['GameTypes'],
		}),
		updateGameType: builder.mutation<
			GameTypeDetail,
			{gameTypeId: string; partialGameType: Partial<GameTypeDetail>}
		>({
			query: ({gameTypeId, partialGameType}) => {
				return {
					input: `${process.env.GATSBY_BACKOFFICE_BASE_URL}/${GAME_TYPES_ENDPOINT}/${gameTypeId}`,
					init: {method: 'PUT', body: JSON.stringify(partialGameType)},
				}
			},
			invalidatesTags: ['GameTypes'],
		}),
	}),
})

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints.
 */
export const {
	useLazyGetGameTypeQuery,
	useLazyGetGameTypesQuery,
	useGetGameTypesQuery,
	useUpdateGameTypeMutation,
} = gameTypeApi
export default gameTypeApi.reducer
